<template>
  <modal class="message-modal" title="一键支付成功" color="warn" buttonsHidden>
    <p class="mb-5">您拥有管理订单的权限，您可以无视支付环节，直接设置该订单为支付成功状态，但是您必须为该订单填写详细备注，是否继续？</p>
    <vx-form class="w-full" layout="h" label-align="center" v-slot="{invalid, handleSubmit}">
      <form-item required label="操作者姓名" >
        <vs-input class="w-full" placeholder="请输入您的姓名" v-model="form.name" />
      </form-item>
      <form-item label="合同号" help="如果是线下支付，请备注合同号">
        <vs-input class="w-full" v-model="form.contract" />
      </form-item>
      <form-item required label="备注" >
        <vs-textarea class="w-full" placeholder="请输入备注" v-model="form.reason" />
      </form-item>
      <vs-button class="mr-2" :disabled="invalid" @click="handleSubmit(submit)">确定成功支付</vs-button>
      <vs-button class="mr-2" color="danger" @click="$modalClose()">取消</vs-button>
    </vx-form>
  </modal>
</template>

<script>
  export default {
    name: "adminPay",
    props: {
      order: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        form: {
          name: '',
          contract: '',
          reason: '',
        }
      }
    },
    methods: {
      async submit() {
        const f = JSON.stringify(this.form)
        const data = {
          ...this.order,
          amount: 0,
          adminPay: f
        }
        const {order} = await this.$s.order.update(data)

        this.$notify({
          title: '订单修改成功',
          // text: '该订单已成功付款，您的修改订单操作将会以邮件形式通知用户'
        })
        this.$modalClose()
        this.$router.push('/order/list')
      }
    },
  }
</script>

<style scoped>

</style>